import { RootState } from '../core'

export const selectCurrencyCode = (state: RootState) => state.currency.code
